import React, { useContext } from 'react'
import { apiContext } from 'services/ApiContext'
import UploadImage from './UploadImage'

import './style.scss'

const CompanyDisplayImage = (props) => {
  const { changeable = true, overridable = false, className, onClick = () => null } = props
  const { project, user, disableEdit } = useContext(apiContext)

  return (
    <div className={`company-display-image ${className}`} onClick={onClick}>
      <UploadImage
        changeable={changeable}
        overridable={overridable}
        project={project}
        user={user}
        disableEdit={disableEdit}
      />
    </div>
  )
}

export default CompanyDisplayImage
